import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { receiptA4Styles } from '../ReceiptPDFA4.styles';
import { getFontFamily } from '../../../badge/pdf/utils';
import { FONT } from '../../../types/enums';
import { getStringWithMultipleReplacements } from '../ReceiptPdf.utils';
import { receiptPriceReplacements } from '../ReceiptPdf.constants';
import { Style } from "@react-pdf/types";

interface Props {
  name: string;
  amount: number;
  price: string;
  badges: string[];
  styles?: Record<'label' | 'value', Style[]>;
}

export const ProductWithBadges: React.FC<Props> = ({amount, name, badges, price, styles = {
  label: [{}],
  value: [{}]
} }) => {
  const productNameStyles = [
    receiptA4Styles.textLeft,
    getFontFamily(`${amount}x ${name}`,
      {fallbackFont: FONT.HELVETICA_BOLD, bold: true })
  ];

  return (
    <View style={receiptA4Styles.paymentsInfoElement}>
      <>
        <View>
          <View style={{justifyContent: 'space-between', flexDirection: 'row', maxWidth: '70%'}}>
            <Text
              style={[
                {marginRight: '3px'},
                ...productNameStyles,
                ...styles.label
              ]}>{amount}x </Text>
            <Text style={[...productNameStyles, ...styles.label]}>{name.trim().replace(/\s\s+/g, ' ').split('')}</Text>
          </View>
          <View style={{marginTop: '5px'}}>
            {badges.map(badge => <Text style={[receiptA4Styles.badgeName, getFontFamily(badge), ...styles.value]}>{badge.split('')}</Text>)}
          </View>
        </View>
        <Text style={[receiptA4Styles.textRight, ...styles.value]}>
          {getStringWithMultipleReplacements(price, receiptPriceReplacements).split('')}
        </Text>
      </>
    </View>
  );
};
